module.exports = __webpack_public_path__ + "static/lottery-button.21fdd440.png";